import { Routes, Route, Navigate } from 'react-router-dom';

import { DevPage } from '@shared/pages'
import { ROUTES_PAYFAC } from '@payfac/constants';
import { CommissionsAnalytics, IndicatorsAnalytics, PendenciesList, RatePlanForm, RatePlanList, RatePlanShow, Rates, Reports, SellersList, TerminalsAnalytics, TransactionsAnalytics } from '@payfac/pages';
import { FeatureToggleProvider } from '@payfac/providers';

import { RootLayout } from '@shared/layouts'
import { Sidebar, Header, UserGuidingIdentify } from './components';

import styles from './payfac-layout.module.css';

export function PayfacLayout() {
    const isDev = import.meta.env.DEV;

    return (
        <RootLayout>
            <UserGuidingIdentify />
            <FeatureToggleProvider>
                <div className={styles.container}>
                    <Header />

                    <main className={styles.main}>
                        <Sidebar />

                        <div className={styles.content}>
                            <Routes>
                                <Route path="/" element={<Navigate to={isDev ? ROUTES_PAYFAC.DEV.path : ROUTES_PAYFAC.RATE_PLANS.path} replace />} />

                                <Route path={ROUTES_PAYFAC.PENDENCIES.path} element={<PendenciesList />} />

                                <Route path={ROUTES_PAYFAC.RATE_PLANS.path} element={<RatePlanList />} />
                                <Route path={ROUTES_PAYFAC.RATE_PLANS.SHOW.path} element={<RatePlanShow />} />
                                <Route path={ROUTES_PAYFAC.RATE_PLANS.FORM.path} element={<RatePlanForm />} />

                                <Route path={ROUTES_PAYFAC.SELLERS.path} element={<SellersList />} />

                                <Route path={ROUTES_PAYFAC.RATES.path} element={<Rates />} />

                                <Route path={ROUTES_PAYFAC.REPORTS.path} element={<Reports />} />

                                <Route path={ROUTES_PAYFAC.TRANSACTIONS.path} element={<TransactionsAnalytics />} />

                                <Route path={ROUTES_PAYFAC.DASHBOARD_INDICATORS.path} element={<IndicatorsAnalytics />} />

                                <Route path={ROUTES_PAYFAC.DASHBOARD_TERMINALS.path} element={<TerminalsAnalytics />} />

                                <Route path={ROUTES_PAYFAC.DASHBOARD_COMMISSIONS.path} element={<CommissionsAnalytics />} />

                                {isDev && <Route path={ROUTES_PAYFAC.DEV.path} element={<DevPage />} />}
                            </Routes>
                        </div>
                    </main>
                </div>
            </FeatureToggleProvider>
        </RootLayout>
    );
}
